import conversionSet from './conversion-set'
import hexdigest from 'lib/hexdigest'

// Emit event on customer loaded (additional request)
// OR after 2 seconds timeout

class EmitViewPageEvent {
  static pushed = false

  static handleCustomerLoaded (customer = null) {
    if (this.pushed) return
    this.pushed = true
    conversionSet.push({
      type: 'event',
      event: 'page_view',
      client_id: customer ? hexdigest('SHA-256', customer.email) : null,
      page_location: window.location.href,
      page_title: document.title,
      user_agent: navigator.userAgent,
    })
  }
}

document.addEventListener('customer:loaded:maybe', () => EmitViewPageEvent.handleCustomerLoaded)

setTimeout(() => {
  if (!EmitViewPageEvent.pushed) EmitViewPageEvent.handleCustomerLoaded()
}, 2000)
